import { useRef, useState, useEffect } from "react"
import TextEditor from "../../component/textEditor/textEditor"

const Content = ({
  elements,
  isEdit,
  activeTab,
  currentContent,
  setContent,
  handleOnChange,
  index,
}: any) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const [isMathJaxReady, setIsMathJaxReady] = useState(false)

  // MathJax rendering - only needed for the HTML content from getContentString
  const typesetMathJax = () => {
    if (window.MathJax && contentRef.current && currentContent) {
      // Small delay to ensure DOM is updated
      setTimeout(() => {
        window.MathJax.typesetPromise([contentRef.current])
          .then(() => setIsMathJaxReady(true))
          .catch((err: any) => console.error("MathJax Render Error:", err))
      }, 200)
    }
  }

  useEffect(() => {
    if (!window.MathJax || !currentContent) {
      setIsMathJaxReady(true) // Show content even if MathJax not loaded
      return
    }
    typesetMathJax()
  }, [currentContent])

  return (
    <div
      className='question_content'
      style={{
        position: "relative",
        overflow: "auto",
        width: "100%",
        height: 500,
        maxHeight: 500,
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
      }}
    >
      {isEdit ? (
        <TextEditor
          value={currentContent}
          height={440}
          handleOnChange={(value: string) =>
            handleOnChange(activeTab.split("_")[0], value, index)
          }
        />
      ) : (
        <div
          ref={contentRef}
          style={{
            position: "relative",
            width: "100%",
            minHeight: "calc(100% - 24px)",
            height: "auto",
            padding: "12px",
            opacity: isMathJaxReady ? 1 : 0.7,
            transition: "opacity 0.3s ease",
            backgroundColor: "#ffffff",
            borderRadius: "4px",
            boxSizing: "border-box",
          }}
          dangerouslySetInnerHTML={{
            __html: currentContent || "<p style='color: #9CA3AF; font-style: italic;'>No content available</p>",
          }}
        />
      )}
    </div>
  )
}

export default Content
